import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/relatorio',
        name: 'Relatorio',
        component: () => import('../views/Relatorio.vue')
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/Painel.vue')
    },
    {
        path: '/restrito',
        name: 'Restrito',
        component: () => import('../views/Restrito.vue')
    },
    {
        path: '/',
        name: 'CadastroInicio',
        component: () => import('../views/Inicio.vue')
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
        path: '/cadastro/',
        name: 'CadastroInicio',
        component: () => import('../views/Inicio.vue')
    },
    {
        path: '/cadastro/aceite',
        name: 'Aceite',
        component: () => import('../views/Aceite.vue')
    },
    {
        path: '/cadastro/perfil',
        name: 'CadastroPerfil',
        component: () => import('../views/FormularioPerfil.vue')
    },
    {
        path: '/cadastro/impacto',
        name: 'CadastroImpacto',
        component: () => import('../views/FormularioImpacto.vue')
    },
    {
        path: '/cadastro/impacto-economico',
        name: 'CadastroImpactoEconomico',
        component: () => import('../views/FormularioImpactoEconomico.vue')
    },
    {
        path: '/cadastro/final',
        name: 'CadastroFinal',
        component: () => import('../views/FormularioFinal.vue')
    },
    {
        path: '/cadastro/concluido',
        name: 'Conclusao',
        component: () => import('../views/Conclusao.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// router.beforeEach(async (to, from, next) => {
//     const rotasProtegidas = ['CadastroPerfil', 'CadastroImpacto', 'CadastroImpactoEconomico', 'CadastroFinal', 'Conclusao'];
//     const aceite = store.state.aceite;
//     if (!(aceite && rotasProtegidas.find(rota => rota === to.name))) {
//         next({name: 'Aceite'});
//     } else {
//         next();
//     }
// });


export default router
